import { render, staticRenderFns } from "./Stars.vue?vue&type=template&id=51fc39b8&scoped=true"
import script from "./Stars.vue?vue&type=script&lang=ts"
export * from "./Stars.vue?vue&type=script&lang=ts"
import style0 from "./Stars.vue?vue&type=style&index=0&id=51fc39b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fc39b8",
  null
  
)

export default component.exports